import css from 'styled-jsx/css'

const PlayfairDisplayBlack = '/fonts/PlayfairDisplayBlack/PlayfairDisplay-Black'
const OpenSansRegular = '/fonts/OpenSansRegular/OpenSans-Regular'
const OpenSansBold = '/fonts/OpenSansBold/OpenSans-Bold'
const NexaBold = '/fonts/NexaBold/Nexa-Bold'
const NexaExtraBold = '/fonts/NexaExtraBold/Nexa-Extra-Bold'
const NexaLight = '/fonts/NexaLight/Nexa-Light'
const NexaRegular = '/fonts/NexaRegular/Nexa-Regular'
const TavirajLight = '/fonts/TavirajLight/Taviraj-Light'
const TavirajExtraLight = '/fonts/TavirajExtraLight/Taviraj-ExtraLight'

export default css.global`
@font-face {
  font-family: 'Playfair Display Black';
  font-display: swap;
  font-weight: 900;
  font-style: normal;
  src: url('${PlayfairDisplayBlack}.eot'),
       url('${PlayfairDisplayBlack}.eot?#iefix') format('embedded-opentype'), 
       url('${PlayfairDisplayBlack}.woff2') format('woff2'), 
       url('${PlayfairDisplayBlack}.woff') format('woff'), 
       url('${PlayfairDisplayBlack}.ttf')  format('truetype'), 
       url('${PlayfairDisplayBlack}.svg#svgFontName') format('svg');
}

@font-face {
  font-family: 'Open Sans Regular';
  font-display: swap;
  font-weight: 400;
  font-style: normal;
  src: url('${OpenSansRegular}.eot'),
       url('${OpenSansRegular}.eot?#iefix') format('embedded-opentype'), 
       url('${OpenSansRegular}.woff2') format('woff2'), 
       url('${OpenSansRegular}.woff') format('woff'), 
       url('${OpenSansRegular}.ttf')  format('truetype'), 
       url('${OpenSansRegular}.svg#svgFontName') format('svg');
}

@font-face {
  font-family: 'Open Sans Bold';
  font-display: swap;
  font-weight: 700;
  font-style: normal;
  src: url('${OpenSansBold}.eot'),
       url('${OpenSansBold}.eot?#iefix') format('embedded-opentype'), 
       url('${OpenSansBold}.woff2') format('woff2'), 
       url('${OpenSansBold}.woff') format('woff'), 
       url('${OpenSansBold}.ttf')  format('truetype'), 
       url('${OpenSansBold}.svg#svgFontName') format('svg');
}

@font-face {
  font-family: 'Nexa Bold';
  font-display: swap;
  font-style: normal;
  font-weight: 700;
  src: url('${NexaBold}.woff2') format('woff2');
}

@font-face {
  font-family: 'Nexa Extra Bold';
  font-display: swap;
  font-style: normal;
  font-weight: 800;
  font-display: swap;
  src: url('${NexaExtraBold}.woff2') format('woff2');
}

@font-face {
  font-family: 'Nexa Light';
  font-display: swap;
  font-style: normal;
  font-weight: 300;
  src: url('${NexaLight}.woff2') format('woff2');
}

@font-face {
  font-family: 'Nexa Regular';
  font-display: swap;
  font-style: normal;
  font-weight: 400;
  src: url('${NexaRegular}.woff2') format('woff2');
}

@font-face {
  font-family: 'Taviraj-Light';
  font-display: swap;
  font-style: normal;
  font-weight: 300;
  src: url('${TavirajLight}.woff2') format('woff2');
}

@font-face {
  font-family: 'Taviraj-ExtraLight';
  font-display: swap;
  font-style: normal;
  font-weight: 200;
  src: 
    url('${TavirajExtraLight}.woff2') format('woff2'),
    url('${TavirajExtraLight}.woff') format('woff'),
    url('${TavirajExtraLight}.eot') format('eot'),
    url('${TavirajExtraLight}.eot?#iefix') format('embedded-opentype'),
    url('${TavirajExtraLight}.ttf')  format('truetype');
  }
`
